<template>
  <div class="auth-success">
    <div class="auth-success__icon">
      <span>✅</span>
    </div>
    <h2 class="auth-success__title">{{ title }}</h2>
    <p class="auth-success__description">{{ description }}</p>

    <BaseButton
      class="auth-success__action"
      :text="buttonText"
      styles="primary-gradient"
      full-width
      vibration="success"
      @on-submit="openMainLink"
    />
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/ui/components/Base/BaseButton.vue'

interface SecondaryLink {
  label: string
  href: string
}

interface Props {
  title: string
  description: string
  buttonLink: string
  buttonText?: string
  secondaryLinks?: SecondaryLink[]
}

const props = withDefaults(defineProps<Props>(), {
  buttonText: 'Перейти на сайт',
  secondaryLinks: () => []
})

const openMainLink = () => {
  window.open(props.buttonLink, '_blank', 'noopener,noreferrer')
}
</script>

<style scoped lang="scss">
.auth-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: $neutral-100;
  text-align: center;
}

.auth-success__icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: rgba(69, 211, 150, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.auth-success__title {
  @include h1;
  margin: 0;
}

.auth-success__description {
  @include p2-regular;
  margin: 0;
  color: $neutral-60;
}

.auth-success__action {
  width: 100%;
}

.auth-success__links {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
}

.auth-success__links-title {
  @include p2-medium;
  margin: 0;
  color: $neutral-60;
}

.auth-success__link {
  @include p2-regular;
  color: $primary-100;
  text-decoration: underline;
}
</style>

